import i18n from '@/application/i18n/i18n'

export const NOTIFICATION_ROUTE = 'notifications.list'
export const NOTIFICATION_DETAILS_ROUTE = 'notifications.details'

export default [
  {
    name: NOTIFICATION_ROUTE,
    path: '/notifications',
    component: () => import('@/features/notifications/pages/NotificationList.vue'),
    meta: {
      pageTitle: () => i18n.t('Notifications'),
      permissions: [
        /* Intentionally left empty */
      ],
    },
  },
  {
    name: NOTIFICATION_DETAILS_ROUTE,
    path: '/notifications/:notificationId',
    component: () => import('@/features/notifications/pages/NotificationDetail.vue'),
    props: route => ({
      notificationId: Number.parseInt(route.params.notificationId),
    }),
    meta: {
      pageTitle: () => i18n.t('Notifications'),
      permissions: [
        /* Intentionally left empty */
      ],
      buttons: [
        {
          id: 'open-notifications-list',
          name: NOTIFICATION_ROUTE,
          title: () => i18n.t('Notifications'),
          mode: 'secondary',
        },
      ],
    },
  },
]
